import { render, staticRenderFns } from "./ProspectsV2.vue?vue&type=template&id=b8e26fe0"
import script from "./ProspectsV2.vue?vue&type=script&lang=js"
export * from "./ProspectsV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports